module.exports = __webpack_public_path__ + "img/icon-sync.8bdb056d.svg";